import script from "./DoTheMathFormInput.vue?vue&type=script&setup=true&lang=js"
export * from "./DoTheMathFormInput.vue?vue&type=script&setup=true&lang=js"

import "./DoTheMathFormInput.vue?vue&type=style&index=0&id=1799ad03&lang=scss"

const __exports__ = script;

export default __exports__